import React from 'react'
import NavBar from "../Components/Navbar"
import Footer from '../Components/Footer'
import HeroImgForPages from '../Components/HeroImgForPages'
import Work from '../Components/Work'
function Projects() {
  return (
    <div>
      <NavBar />
      <HeroImgForPages heading="PROJECTS" text="Some of my most recent works" />
      <Work />
      <Footer />
      </div>
  )
}

export default Projects